import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import ic_no_logo from "../../img/no_logo.svg";
import { getAllModuleImages } from "../../utils/MenuModulePathAndLogoListOfThisProduct";
import CubixLogo from "../../img/cubix-logo_R.png";
const Sidebar = (props) => {
  const navigate = useNavigate();
  const module_list = getAllModuleImages();
  const sidebarRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const {
    isModulePanelExpanded,
    setIsModulePanelExpanded,
    setCurrentSelectedMouleObject,
    currentSelectedMouleObject,
    groupedModuleSubmoduleMain,
    onSignOut,
  } = props;

  const [hideLeftSideBar, setHideLeftSideBar] = useState(true);

  useEffect(() => {
    if (groupedModuleSubmoduleMain && !currentSelectedMouleObject) {
      setCurrentSelectedMouleObject(groupedModuleSubmoduleMain[0]);
    }
  }, [groupedModuleSubmoduleMain]);

  return (
    <>
      <aside
        ref={sidebarRef}
        className="fixed md:relative w-20 flex flex-col  h-[calc(100vh-80px)]"
      >
        <nav className="flex-1 overflow-y-auto overflow-x-hidden py-4 px-3 custom-scrollbar ">
          <ul className="space-y-4">
            {groupedModuleSubmoduleMain?.map((item) => {
              const isActive =
                currentSelectedMouleObject?.MODULEID === item.MODULEID;
              const moduleIcon = module_list.find(
                (m) => m.module_id === item.MODULEID,
              )?.image;

              return (
                <li
                  key={item.MODULEID}
                  className="relative group flex justify-center"
                >
                  <button
                    onClick={() => {
                      setCurrentSelectedMouleObject(item);
                      navigate("/home");
                    }}
                    className={`
                      relative flex items-center justify-center w-12 h-12 rounded-2xl transition-all duration-300
                      ${
                        isActive
                          ? "bg-blue-600 shadow-lg shadow-blue-200"
                          : "bg-white border border-gray-100 text-slate-400 hover:border-blue-200 hover:bg-blue-50 hover:text-blue-600"
                      }
                    `}
                  >
                    {/* Module Icon */}
                    <img
                      src={moduleIcon || ic_no_logo}
                      className={`w-6 h-6 object-contain transition-all duration-300 ${
                        isActive
                          ? "brightness-0 invert scale-110"
                          : "group-hover:scale-110"
                      }`}
                      alt=""
                    />

                    {/* Active Pulse (Optional Indicator) */}
                    {isActive && (
                      <span className="absolute -left-1 w-1 h-6 bg-blue-600 rounded-r-full" />
                    )}

                    {/* OVERLAY TOOLTIP / LABEL */}
                    <div className="absolute left-16 px-4 py-3 bg-white border border-gray-100 shadow-2xl rounded-2xl opacity-0 invisible -translate-x-3 group-hover:opacity-100 group-hover:visible group-hover:translate-x-0 transition-all duration-300  min-w-[180px]">
                      <div className="flex items-center justify-between">
                        <div className="flex flex-col items-start">
                          <span className="text-[10px] text-blue-600 font-bold uppercase tracking-widest mb-1">
                            Module
                          </span>
                          <span className="text-sm font-extrabold text-slate-800 whitespace-nowrap">
                            {item.MODULENAME}
                          </span>
                        </div>
                        <ChevronRight size={16} className="text-slate-300" />
                      </div>
                      {/* Arrow tail for the overlay */}
                      <div className="absolute top-1/2 -left-2 -translate-y-1/2 w-4 h-4 bg-white border-l border-b border-gray-100 rotate-45" />
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
        <div className=" flex flex-col items-center gap-1">
          <img
            src={CubixLogo}
            alt="Parent Company"
            className="w-20  object-contain cursor-pointer "
          />
          <span className="text-[10px] text-slate-400 font-semibold">
            v {process.env.REACT_APP_VERSION}{" "}
          </span>
        </div>
      </aside>
      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 0px; }
        .custom-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        
        /* Smooth backdrop blur for the main content when hovering sidebar (optional) */
        aside:hover ~ main {
          filter: blur(1px);
          transition: 0.3s;
        }
      `}</style>
    </>
  );
};

export default Sidebar;
